//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { setQueryParam } from '@utils/urlUtils';
import { GALLERY_CONTAINER_ID_QUERY_PARAM } from '@galleries/constants/galleriesConstants';
import GalleryContainerId from '@galleries/models/GalleryContainerId';

export const setSelectedGalleryQueryParam = (
  selectedGalleryId: GalleryContainerId | undefined,
) => {
  const urlWithContainerId = setQueryParam(
    window.location.href,
    GALLERY_CONTAINER_ID_QUERY_PARAM,
    selectedGalleryId,
  );
  history.replaceState(null, '', urlWithContainerId);
};
